<script setup lang="ts">
// Permanent entry point to reopen the preferences once the banner is gone.
// Withdrawing consent must be as easy as giving it (GDPR art. 7(3)): one click,
// from every page, no account needed. SmartWay's own site uses the same pattern.
//
// BOTTOM-RIGHT on purpose, not bottom-left like smartway.es: inside the app the
// side menu (DashboardSideMenu) is an opaque, full-height `fixed left-0 z-60`
// column that would hide a z-40 button, and its bottom-left corner holds the Help
// button and the version label, so raising the z-index would just cover those.
// right-6 (not right-3) also keeps it clear of the content scrollbar.
import { Cookie } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useConsentStore } from '@/stores/consentStore'

const { t } = useI18n()
const store = useConsentStore()
</script>

<template>
  <button
    type="button"
    class="fixed bottom-4 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-smartway-blue text-white shadow-lg transition duration-150 ease-out hover:scale-110 hover:bg-[#1a1699] hover:shadow-xl motion-reduce:transition-none motion-reduce:hover:scale-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-smartway-blue"
    :aria-label="t('components.cookieConsent.settingsButton.label')"
    :title="t('components.cookieConsent.settingsButton.label')"
    data-cookie-return-focus
    data-testid="cookie-settings-button"
    @click="store.openPreferences()"
  >
    <Cookie :size="22" aria-hidden="true" />
  </button>
</template>
